import IMG7 from "../assets/projects/dogs-app/dogs-app-min.png";
import IMG1 from "../assets/projects/kaprichosnails/kprichosnails-min.png";
import IMG10 from "../assets/projects/medellin-participa/medellin_participa-min.png";
import IMG11 from "../assets/projects/barbershop/barber_app.png";
import IMG3 from "../assets/projects/netflix-clone/netflix-clon-min.png";
import IMG2 from "../assets/projects/portfolio/portfolio-min.png";
import IMG9 from "../assets/projects/sigpex/sigpex-min.png";
import IMG4 from "../assets/projects/spotify-clone/spotify-clon-min.png";
import IMG8 from "../assets/projects/tu-spacio/tu-spacio-min.png";
import IMG12 from "../assets/projects/bizsocial/BizSocial_Login-1.png";
import IMG13 from "../assets/projects/bizsocial/BizSocial_Feed.png";
import IMG14 from "../assets/projects/bizsocial/BizSocial_Chat.png";
import IMG15 from "../assets/projects/bizsocial/BizSocial_Relatorios.png";
import IMG16 from "../assets/projects/bizsocial/BizSocial_Login-2.png";

export const projects = [
    {
    id: 1,  
    image: IMG12,
    title: "BizSocial",
    description: "description10",
    github: "https://github.com/ENDERSON-MARIN/BIZSOCIAL-SHOWCASE",
    demo: "https://endersonmillan.com/",
    video: "https://www.youtube.com/@millanendersondev",
    stack: ["html", "css", "ts", "react", "next.js", "shadcn-ui", "postgresql", "prisma", "stripe", "docker", "git"],
    images: [
        { src: IMG16, alt: "BizSocial - Main Login" },
        { src: IMG13, alt: "BizSocial - Feet" },
        { src: IMG14, alt: "BizSocial - Chat" },
        { src: IMG15, alt: "BizSocial - Rlatorios" }
      ]
    },
    {
    id: 2,  
    image: IMG11,
    title: "Barbershop",
    description: "description1",
    github: "https://github.com/ENDERSON-MARIN/BARBERSHOP-APP/",
    demo: "https://barbershop.endersonmillan.com/",
    video: "https://www.youtube.com/@millanendersondev",
    stack: ["html", "css", "ts", "react", "next.js", "shadcn-ui", "postgresql", "prisma", "stripe", "docker", "git"],
    images: [
      { src: IMG11, alt: "Barbershop - Main view" },
      { src: IMG11, alt: "Barbershop - Admin panel" },
      { src: IMG11, alt: "Barbershop - Bookings" },
      { src: IMG11, alt: "Barbershop - Services" }
    ]
  },
  {
    id: 3,
    image: IMG10,
    title: "Medellin Participa",
    description: "description2",
    github: "https://github.com/ENDERSON-MARIN/",
    demo: "https://www.medellin.gov.co/es/",
    video: "https://www.youtube.com/@millanendersondev",
    stack: ["html", "css", "js", "ts", "angular", "php", "laravel", "mysql", "gitlab", "jira", "scrum"],
    images: [
      { src: IMG10, alt: "Medellin Participa - Main page" },
      { src: IMG10, alt: "Medellin Participa - Citizen services" },
      { src: IMG10, alt: "Medellin Participa - Public information" },
      { src: IMG10, alt: "Medellin Participa - Important information" }
    ]
  },
  {
    id: 4,
    image: IMG8,
    title: "Tu Spacio",
    description: "description3",
    github: "https://github.com/ENDERSON-MARIN/",
    demo: "https://tuspacio.vercel.app/",
    video: "https://www.youtube.com/@millanendersondev",
    stack: ["html", "css", "js", "react", "material-ui", "node.js", "postgresql", "git", "scrum", "trello"],
    images: [
      { src: IMG8, alt: "Tu Spacio - Product catalog" },
      { src: IMG8, alt: "Tu Spacio - Shopping cart" },
      { src: IMG8, alt: "Tu Spacio - Appointment booking" },
      { src: IMG8, alt: "Tu Spacio - Payment methods" }
    ]
  },
  {
    id: 5,
    image: IMG1,
    title: "Kaprichosnails",
    description: "description4",
    github: "https://github.com/ENDERSON-MARIN/",
    demo: "http://kprichosnails.store/",
    video: "https://www.youtube.com/@millanendersondev",
    stack: ["html", "css", "js", "php", "wordpress", "wordpress-plugins", "elementor", "woocommerce", "mysql", "git"],
    images: [
      { src: IMG1, alt: "Kaprichosnails - Design gallery" },
      { src: IMG1, alt: "Kaprichosnails - Services" },
      { src: IMG1, alt: "Kaprichosnails - Online store" },
      { src: IMG1, alt: "Kaprichosnails - Appointment booking" }
    ]
  },
  {
    id: 6,
    image: IMG9,
    title: "SIGPEX",
    description: "description5",
    github: "https://github.com/ENDERSON-MARIN/",
    demo: "https://www.hercascrm.co/sigpex/public/admin/login",
    video: "https://www.youtube.com/@millanendersondev",
    stack: ["html", "css", "js", "bootstrap", "php", "laravel", "mysql", "blade", "mysql", "git"],
    images: [
      { src: IMG9, alt: "SIGPEX - Main dashboard" },
      { src: IMG9, alt: "SIGPEX - Customer management" },
      { src: IMG9, alt: "SIGPEX - Quote management" },
      { src: IMG9, alt: "SIGPEX - Report management" }
    ]
  },
  {
    id: 7,
    image: IMG2,
    title: "Enderson Millan",
    description: "description6",
    github: "https://github.com/ENDERSON-MARIN/",
    demo: "https://portafolio-react-enderson-marin.vercel.app/",
    video: "https://www.youtube.com/@millanendersondev",
    stack: ["html", "css", "js", "react", "ts", "git", "emailjs", "i18next", "framer-motion", "swiper", "sweetalert2"],
    images: [
      { src: IMG2, alt: "Portfolio - Main page" },
      { src: IMG2, alt: "Portfolio - About me" },
      { src: IMG2, alt: "Portfolio - Projects" },
      { src: IMG2, alt: "Portfolio - Contact" }
    ]
  },
  {
    id: 8,
    image: IMG3,
    title: "Netflix Clone",
    description: "description7",
    github: "https://github.com/ENDERSON-MARIN/",
    demo: "https://netflix-clon-enderson-marin.vercel.app/",
    video: "https://www.youtube.com/@millanendersondev",
    stack: ["html", "css", "js", "react",  "redux", "material-ui", "styled-components", "sweetalert2", "paypal", "git"],
    images: [
      { src: IMG3, alt: "Netflix Clone - Movie catalog" },
      { src: IMG3, alt: "Netflix Clone - Player" },
      { src: IMG3, alt: "Netflix Clone - My list" },
      { src: IMG3, alt: "Netflix Clone - New releases" }
    ]
  },
  {
    id: 9,
    image: IMG4,
    title: "Spotify Clone",
    description: "description8",
    github: "https://github.com/ENDERSON-MARIN/",
    demo: "https://spotify-clon-enderson-marin.vercel.app/",
    video: "https://www.youtube.com/@millanendersondev",
    stack: ["html", "css", "js", "react",  "redux", "material-ui", "styled-components", "sweetalert2", "paypal", "git"],
    images: [
      { src: IMG4, alt: "Spotify Clone - Music library" },
      { src: IMG4, alt: "Spotify Clone - Player" },
      { src: IMG4, alt: "Spotify Clone - Playlists" },
      { src: IMG4, alt: "Spotify Clone - Artists" }
    ]
  },
  {
    id: 10,
    image: IMG7,
    title: "Dogs Informative",
    description: "description9",
    github: "https://github.com/ENDERSON-MARIN/",
    demo: "https://dogs-app-enderson-marin.vercel.app/",
    video: "https://www.youtube.com/@millanendersondev",
    stack: ["html", "css", "js", "react", "redux", "nodejs", "express", "postgresql", "sequelize", "git"],
    images: [
      { src: IMG7, alt: "Dogs App - Breed catalog" },
      { src: IMG7, alt: "Dogs App - Breed details" },
      { src: IMG7, alt: "Dogs App - Favorites" },
      { src: IMG7, alt: "Dogs App - Create new" }
    ]
  },
];

export const recentProjects = projects.slice(0, 3);
